import React, { useState, useEffect, useRef } from 'react';
import {useLocation} from 'react-router-dom';
import style from './PhoneNumInfo.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import CallButtonBox from '../../../../../components/box/CallButtonBox';

//tab
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';



const PhoneNumInfo = () => {

   const location = useLocation();
   const { hospitCd } = location.state || {};

   const hosptCd = hospitCd  // 병원 코드 

   const hospitalinfo = {
        "012": {
            name: "서울성모병원",
            phoneNumber: "1588-1511"
        },
        "011": {
            name: "여의도성모병원",
            phoneNumber: "1661-7575"
        },
        "015": {
            name: "은평성모병원",
            phoneNumber: "1811-7755"
        },
        "013": {
            name: "의정부성모병원",
            phoneNumber: "1661-7500"
        },
        "014": {
            name: "부천성모병원",
            phoneNumber: "1577-0675"
        },
        "016": {
            name: "인천성모병원",
            phoneNumber: "1544-9004"
        },
        "018": {
            name: "대전성모병원",
            phoneNumber: "1577-0888"
        },
    };

    const hospital = hospitalinfo[hosptCd];

    // Tab
   const [value, setValue] = useState('1');
   
   const handleChange = (event, newValue) => {
      setValue(newValue);   
   };

    return ( 
        <>
            <HeadSub title="주요 전화번호 안내" hospitalName={hospital.name}/>

                <div id="sub-content" data-type="b" data-layout="white">
                    <div className='inner-wrap' data-padding="0">

                        <div className={style['top-box']}>
                           
                           {hospital?.phoneNumber && (
                                <CallButtonBox type="b" hospital={hospital.name} phoneNumber={hospital.phoneNumber} /> 
                            )}

                        </div>    
                            
                        <div className={style['mid-box']}>


                           {/* 서울성모병원::S */}
                           {hosptCd === "012" && (
                              <div className={style['cont-box']}>
                                 <span className={style['reference-txt']}>대표 전화 연결 후 상담 또는 안내를 원하시는 번호를 선택해주세요. </span>    

                                 <div className={style['phone-list']} data-type="a">
                                    <ul>
                                       <li>
                                          <p>진료예약 및 상담 및 검사예약변경</p>
                                          <span data-circle="a">1</span> 
                                       </li>
                                       <li>
                                          <p>진료예약일자 확인</p>
                                          <span data-circle="a">2</span> 
                                       </li>
                                       <li>
                                          <p>치과병원 예약상담</p>
                                          <span data-circle="a">3</span> 
                                       </li>
                                       <li>
                                          <p>건강검진 예약상담</p>
                                          <span data-circle="a">4</span> 
                                       </li>
                                       <li>
                                          <p>병원이용 및 진료시간 안내</p>
                                          <div className={style['span-group']}>
                                                <span data-circle="a">5</span> <i>+</i>
                                                <span data-circle="b">1</span>
                                          </div>   
                                       </li>

                                       <li>
                                          <p>병원위치 및 교통편안내</p>
                                          <div className={style['span-group']}>
                                                <span data-circle="a">5</span> <i>+</i>
                                                <span data-circle="b">2</span>
                                          </div>   
                                       </li>
                                       <li>
                                          <p>주차이용안내</p>
                                          <div className={style['span-group']}>
                                                <span data-circle="a">5</span> <i>+</i>
                                                <span data-circle="b">3</span>
                                          </div>   
                                       </li>
                                       <li>
                                          <p>제증명 발급안내</p>
                                          <div className={style['span-group']}>
                                                <span data-circle="a">5</span> <i>+</i>
                                                <span data-circle="b">4</span>
                                          </div>   
                                       </li>
                                       <li>
                                          <p>입원안내</p>
                                          <span data-circle="a">6</span> 
                                       </li>

                                       <li>
                                          <p>장례식장 안내(02-2258-5940)</p>
                                          <span data-circle="a">7</span> 
                                       </li>
                                       <li>
                                          <p>기타안내</p>
                                          <span data-circle="a">0 </span> 
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           )}
                           {/* 서울성모병원::E */}


                           {/* 여의도성모병원::S */}
                           {hosptCd === "011" && (
                              <div className={style['cont-box']}>
                                 <div className={style['phone-list']} data-type="b">
                                    <ul>
                                       <li>
                                          <p>FAX</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-780-9114</span>
                                                   <button className={style['no-call']}></button>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>진료예약 및 변경</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>1661-7575</span>
                                                   <CallButtonBox type="c" phoneNumber="1661-7575"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li> 
                                       <li>
                                          <p>장례식장</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-3779-1526</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-1526"/>
                                                </li>
                                                <li>
                                                   <span>02-3779-2181</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-2181"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>입원수속</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-3779-1313</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-1313"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>퇴원수속</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-3779-1086</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-1086"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>제증명서 발급</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-3779-1516</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-1516"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>영상기록CD 등록 및 발급</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-3779-2326</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-2326"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>병리과 슬라이드 대출·발급</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-3779-2371</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-2371"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>의무기록사본 발행</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-3779-2326</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-2326"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>중증진료신청</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-3779-2327</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-2327"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>원목실</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-3779-1106</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-1106"/>
                                                </li>
                                                <li>
                                                   <span>02-3779-1107</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-1107"/>
                                                </li>
                                                <li>
                                                   <span>02-3779-2356</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-2356"/>
                                                </li>

                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>호스피스</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-3779-2558</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-2558"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>자원봉사</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-3779-1962</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-1962"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>가정간호</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-3779-1688</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-1688"/>
                                                </li>
                                                <li>
                                                   <span>02-3779-1216</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-1216"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>

                                       <li>
                                          <p>사회사업(기부후원)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-3779-1881~5</span>
                                                   <CallButtonBox type="c" phoneNumber="02-3779-1881"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>


                                    </ul>
                                 </div>
                              </div>
                           )}
                           {/* 여의도성모병원::E */}


                           {/* 은평성모병원::S */}
                           {hosptCd === "015" && (
                              <div className={style['cont-box']}>
                                 <div className={style['phone-list']} data-type="b">
                                    <ul>
                                       <li>
                                          <p>전화예약</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>1811-7755</span>
                                                   <CallButtonBox type="c" phoneNumber="1811-7755"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>입원안내</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3638~9</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3638"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li> 
                                       <li>
                                          <p>원무통합창구(대표전화)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3645</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3645"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>원무사무실(진료비상담)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3618, 3630</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3618"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>원무(신체감정)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3633</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3633"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>원무(산업재해)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-3779-1516</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3633"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>원무(자동차보험)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3623</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3623"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>원무(자동차보험)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>FAX 02-2030-3624</span>
                                                   <button className={style['no-call']}></button>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>응급원무</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3646</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3646"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>의무기록사본발행</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3323~5</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3323"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>검사통합예약</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3804~5</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3804"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>약국(입원)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3401</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3401"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>약국(외래)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3411</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3411"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>가정간호</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3823~4</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3823"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>간호행정팀</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3773</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3773"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>건강증진센터</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>1811-6600</span>
                                                   <CallButtonBox type="c" phoneNumber="1811-6600"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>구매관리팀</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3541</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3541"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>노동조합</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-4966</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-4966"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>분실물</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3112</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3112"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>비즈니스센터</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3670</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3670"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>시설팀(전기)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3605</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3605"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>시설팀(설비)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3595</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3595"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>시설팀(시설관리)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3578~82</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3578"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>원목실</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3443</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3443"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>인공신장실</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3812</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3812"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>인사팀(채용)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3509</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3509"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>인사팀(제증명)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3512</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3512"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>자원봉사실</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3456</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3456"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>장기기증</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-2639</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-2639"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>장례식장</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-4441~2</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-4441"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>주차안내(정산소)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-4981~2</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-4981"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>진료협력센터</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-2567</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-2567"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>총무팀</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-3518</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-3518"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>호스피스</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>02-2030-4296</span>
                                                   <CallButtonBox type="c" phoneNumber="02-2030-4296"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           )}
                           {/* 은평성모병원::E */}


                           {/* 의정부성모병원::S */}
                           {hosptCd === "013" && (
                              <div className={style['cont-box']}>
                                 <div className={style['phone-list']} data-type="b">
                                    <ul>
                                       <li>
                                          <p>FAX</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>031-820-3516</span>
                                                   <button className={style['no-call']}></button>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>진료비내역상담</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>031-820-3436</span>
                                                   <CallButtonBox type="c" phoneNumber="031-820-3436"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li> 
                                       <li>
                                          <p>건강증진센터</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>031-820-3330</span>
                                                   <CallButtonBox type="c" phoneNumber="031-820-3330"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>퇴원진료비계산</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>031-820-3441</span>
                                                   <CallButtonBox type="c" phoneNumber="031-820-3441"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>주차안내(정산소)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>031-820-3296</span>
                                                   <CallButtonBox type="c" phoneNumber="031-820-3296"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>주차안내(정산소/야간)</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>031-820-5256</span>
                                                   <CallButtonBox type="c" phoneNumber="031-820-5256"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>전화예약</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>1661-7500</span>
                                                   <CallButtonBox type="c" phoneNumber="1661-7500"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>고객지원센터</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>031-820-3787</span>
                                                   <CallButtonBox type="c" phoneNumber="031-820-3787"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>장례식장</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>031-820-3468</span>
                                                   <CallButtonBox type="c" phoneNumber="031-820-3468"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>원목팀</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>031-820-3472</span>
                                                   <CallButtonBox type="c" phoneNumber="031-820-3472"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>호스피스과</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>031-820-3357</span>
                                                   <CallButtonBox type="c" phoneNumber="031-820-3357"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>사회사업팀</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>031-820-3470</span>
                                                   <CallButtonBox type="c" phoneNumber="031-820-3470"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>가정간호과</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>031-820-3356</span>
                                                   <CallButtonBox type="c" phoneNumber="031-820-3356"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           )}
                           {/* 의정부성모병원::E */}


                           {/* 부천성모병원::S */}
                           {hosptCd === "014" && (
                              <div className={style['cont-box']}>
                                 <div className={style['phone-list']} data-type="b">
                                    <ul>
                                       <li>
                                          <p>FAX</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>032-340-2255</span>
                                                   <button className={style['no-call']}></button>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>분만실</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>032-340-2068</span>
                                                   <CallButtonBox type="c" phoneNumber="032-340-2068"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li> 
                                       <li>
                                          <p>종합검진센터</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>032-340-2160</span>
                                                   <CallButtonBox type="c" phoneNumber="032-340-2160"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>건강검진실</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>032-340-2168</span>
                                                   <CallButtonBox type="c" phoneNumber="032-340-2168"/>
                                                </li>
                                                <li>
                                                   <span>032-340-2169</span>
                                                   <CallButtonBox type="c" phoneNumber="032-340-2169"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>진료협력센터</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>032-340-7890</span>
                                                   <CallButtonBox type="c" phoneNumber="032-340-7890"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>장례식장</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>032-340-7300</span>
                                                   <CallButtonBox type="c" phoneNumber="032-340-7300"/>
                                                </li>
                                                <li>
                                                   <span>032-340-7370</span>
                                                   <CallButtonBox type="c" phoneNumber="032-340-7370"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>가정간호팀</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>032-340-2649</span>
                                                   <CallButtonBox type="c" phoneNumber="032-340-2649"/>
                                                </li>
                                                <li>
                                                   <span>032-340-2650</span>
                                                   <CallButtonBox type="c" phoneNumber="032-340-2650"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                    </ul>
                                 </div>
                              </div>
                           )}
                           {/* 부천성모병원::E */}


                           {/* 인천성모병원::S */}
                           {hosptCd === "016" && (
                              <div className={style['cont-box']}>
                                 <div className={style['phone-list']} data-type="b">
                                    <ul>
                                       <li>
                                          <p>FAX</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>042-252-6807</span>
                                                   <button className={style['no-call']}></button>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>종합안내</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>032-280-5078</span>
                                                   <CallButtonBox type="c" phoneNumber="032-280-5078"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li> 
                                       <li>
                                          <p>종합검진센터/건강관리센터</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>1544-9004(내선2)</span>
                                                   <CallButtonBox type="c" phoneNumber="1544-9004"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>입원안내</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>032-280-6370</span>
                                                   <CallButtonBox type="c" phoneNumber="032-280-6370"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>퇴원안내</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>032-280-6372</span>
                                                   <CallButtonBox type="c" phoneNumber="032-280-6372"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       <li>
                                          <p>장례식장</p>
                                          <div className={style['group-box']}>
                                             <ul>
                                                <li>
                                                   <span>032-280-6469</span>
                                                   <CallButtonBox type="c" phoneNumber="032-280-6469"/>
                                                </li>
                                             </ul>
                                          </div>
                                       </li>
                                       
                                    </ul>
                                 </div>
                              </div>
                           )}
                           {/* 인천성모병원::E */}


                           {/* 대전성모병원::S */}   
                           {hosptCd === "018" && (
                              <TabContext value={value}>
                                 <div className="top-tab-head" data-type="b">
                                       <TabList
                                          onChange={handleChange}
                                          aria-label="lab API tabs example"
                                          variant="scrollable"
                                          scrollButtons={false}
                                          className={style['tab-lists']}
                                       >
                                          <Tab label="주요전화번호" value="1" disableRipple />
                                          <Tab label="원목실" value="2" disableRipple />
                                          <Tab label="진료부" value="3" disableRipple />
                                          <Tab label="주요센터" value="4" disableRipple />
                                          <Tab label="병동 및 중환자실" value="5" disableRipple />
                                          <Tab label="진료지원팀" value="6" disableRipple />
                                          <Tab label="간호부" value="7" disableRipple />
                                          <Tab label="기획조정실/관리부" value="8" disableRipple />
                                       </TabList>
                                 </div>

                                    <div className={style['cont-box']}>
                                       <TabPanel value="1">
                                          <div className={style['phone-list']} data-type="b">
                                             <ul>
                                                <li>
                                                   <p>응급의료센터</p>
                                                   <div className={style['group-box']}>
                                                      <ul>
                                                         <li>
                                                            <span>042-220-9119</span>
                                                            <CallButtonBox type="c" phoneNumber="042-220-9119"/>
                                                         </li>
                                                      </ul>
                                                   </div>
                                                </li>
                                                <li>
                                                   <p>안내(1층)</p>
                                                   <div className={style['group-box']}>
                                                      <ul>
                                                         <li>
                                                            <span>042-220-9426</span>
                                                            <CallButtonBox type="c" phoneNumber="042-220-9426"/>
                                                         </li>
                                                      </ul>
                                                   </div>
                                                </li> 
                                                <li>
                                                   <p>호스피스</p>
                                                   <div className={style['group-box']}>
                                                      <ul>
                                                         <li>
                                                            <span>042-220-9755</span>
                                                            <CallButtonBox type="c" phoneNumber="042-220-9755"/>
                                                         </li>
                                                      </ul>
                                                   </div>
                                                </li>
                                                <li>
                                                   <p>분만실</p>
                                                   <div className={style['group-box']}>
                                                      <ul>
                                                         <li>
                                                            <span>042-220-9555</span>
                                                            <CallButtonBox type="c" phoneNumber="042-220-9555"/>
                                                         </li>
                                                      </ul>
                                                   </div>
                                                </li>
                                                <li>
                                                   <p>차량운영팀(주차관리)</p>
                                                   <div className={style['group-box']}>
                                                      <ul>
                                                         <li>
                                                            <span>042-220-9425</span>
                                                            <CallButtonBox type="c" phoneNumber="042-220-9425"/>
                                                         </li>
                                                      </ul>
                                                   </div>
                                                </li>
                                                <li>
                                                   <p>진료협력센터</p>
                                                   <div className={style['group-box']}>
                                                      <ul>
                                                         <li>
                                                            <span>042-220-9052</span>
                                                            <CallButtonBox type="c" phoneNumber="042-220-9052"/>
                                                         </li>
                                                      </ul>
                                                   </div>
                                                </li>
                                                <li>
                                                   <p>종합건강증진센터</p>
                                                   <div className={style['group-box']}>
                                                      <ul>
                                                         <li>
                                                            <span>042-220-98912</span>
                                                            <CallButtonBox type="c" phoneNumber="042-220-98912"/>
                                                         </li>
                                                         <li>
                                                            <span>공단검진 98967</span>
                                                            <CallButtonBox type="c" phoneNumber="042-220-98967"/>
                                                         </li>
                                                      </ul>
                                                   </div>
                                                </li>
                                                <li>
                                                   <p>간호부</p>
                                                   <div className={style['group-box']}>
                                                      <ul>
                                                         <li>
                                                            <span>042-220-9661~2</span>
                                                            <CallButtonBox type="c" phoneNumber="042-220-9661"/>
                                                         </li>
                                                      </ul>
                                                   </div>
                                                </li>
                                                <li>
                                                   <p>영상진단센터(PET-CT)</p>
                                                   <div className={style['group-box']}>
                                                      <ul>
                                                         <li>
                                                            <span>042-220-9995</span>
                                                            <CallButtonBox type="c" phoneNumber="042-220-9995"/>
                                                         </li>
                                                      </ul>
                                                   </div>
                                                </li>
                                                <li>
                                                   <p>진료상담</p>
                                                   <div className={style['group-box']}>
                                                      <ul>
                                                         <li>
                                                            <span>042-220-9007</span>
                                                            <CallButtonBox type="c" phoneNumber="042-220-9007"/>
                                                         </li>
                                                      </ul>
                                                   </div>
                                                </li>
                                                <li>
                                                   <p>영상진단센터</p>
                                                   <div className={style['group-box']}>
                                                      <ul>
                                                         <li>
                                                            <span>042-220-9689</span>
                                                            <CallButtonBox type="c" phoneNumber="042-220-9689"/>
                                                         </li>
                                                      </ul>
                                                   </div>
                                                </li>
                                                <li>
                                                   <p>장례식장</p>
                                                   <div className={style['group-box']}>
                                                      <ul>
                                                         <li>
                                                            <span>042-220-9870~2</span>
                                                            <CallButtonBox type="c" phoneNumber="042-220-9870"/>
                                                         </li>
                                                      </ul>
                                                   </div>
                                                </li>
                                             </ul>
                                          </div>      
                                       </TabPanel>

                                       <TabPanel value="2">
                                          <div className={style['phone-list']} data-type="b">
                                                <ul>
                                                   <li>
                                                      <p>원목실</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9927</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9927"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>원목팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9927, 9416</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9927"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li> 
                                                   <li>
                                                      <p>호스피스팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9004</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9004"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>사회사업팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9005</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9005"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>자원봉사실</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9417</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9417"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                </ul>
                                          </div>     
                                       </TabPanel>

                                       <TabPanel value="3">
                                          <div className={style['phone-list']} data-type="b">
                                                <ul>
                                                   <li>
                                                      <p>소화기내과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9823~5</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9823"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>영상의학과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9620, 9111</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9620"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li> 
                                                   <li>
                                                      <p>종양혈액내과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9821~2</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9821"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>가정의학과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9523</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9523"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>심장내과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9500</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9500"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>내분비내과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9100</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9100"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>신장내과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9101</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9101"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>응급의학과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9119</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9119"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>외과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9520</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9520"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>소아청소년과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9540</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9540"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>류마티스내과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9511</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9511"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>신경과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9010</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9010"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>호흡기 및 알레르기내과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9708</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9708"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>신경외과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9525</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9525"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>감염내과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9510</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9510"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>마취통증의학과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9040</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9040"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>정형외과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9530</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9530"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>안과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9590</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9590"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>산부인과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9550~1</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9550"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>피부과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9560</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9560"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>정신건강의학과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9020</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9020"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>진단검사의학과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9610</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9610"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>심장혈관흉부외과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9570</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9570"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>방사선종양학과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9630</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9630"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>성형외과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9050</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9050"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>재활의학과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9650</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9650"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>이비인후과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9580</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9580"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>치과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9030</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9030"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>비뇨의학과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9090</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9090"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>병리과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9866</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9866"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>핵의학과</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9640</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9640"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                </ul>
                                          </div>     
                                       </TabPanel>

                                       <TabPanel value="4">
                                          <div className={style['phone-list']} data-type="b">
                                                <ul>
                                                   <li>
                                                      <p>응급의료센터</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9119</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9119"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>종합건강증진센터</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9891~2</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9891"/>
                                                            </li>
                                                            <li>
                                                               <span>공단검진 9896~7</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9896"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li> 
                                                   <li>
                                                      <p>관절센터</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9860</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9860"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>뇌신경센터</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9647</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9647"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>발달장애센터</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9650</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9650"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>소화기내시경센터</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9501~2</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9501"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>심혈관센터</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9686, 9942~3</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9686"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>암센터</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9520</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9520"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>유방센터</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9729</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9729"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>장기이식센터</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9515</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9515"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>통증센터</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9040</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9040"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>호흡기알레르기센터</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9708</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9708"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>진료협력센터</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9427</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9427"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>로봇수술센터</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>해당 진료과</span>
                                                               <CallButtonBox type="c" phoneNumber=""/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                </ul>
                                          </div>     
                                       </TabPanel>

                                       <TabPanel value="5">
                                          <div className={style['phone-list']} data-type="b">
                                                <ul>
                                                   <li>
                                                      <p>32병동(생명사랑동)</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9576</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9576"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>33병동</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9735</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9735"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li> 
                                                   <li>
                                                      <p>51병동</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9127, 9725</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9127"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>52병동</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9951</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9951"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>53병동(호스피스병동)</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9755</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9755"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>63병동</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9850</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9850"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>71병동</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9770</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9770"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>72병동</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9775</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9775"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>73병동</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9840</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9840"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>81병동</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9780</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9780"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>82병동</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9783</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9783"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>91병동</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9790</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9790"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>92병동</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9193</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9193"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>제 1중환자실</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9690~1</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9690"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>제 2중환자실</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9680~1</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9680"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                </ul>
                                          </div>     
                                       </TabPanel>

                                       <TabPanel value="6">
                                          <div className={style['phone-list']} data-type="b">
                                                <ul>
                                                   <li>
                                                      <p>임상도서실</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9685</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9685"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>수술실</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9670</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9670"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li> 
                                                   <li>
                                                      <p>인공신장실</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9508</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9508"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>재활치료실</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9653</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9653"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>외래주사실</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9664</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9664"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>의료정보팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9121</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9121"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>약제팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9492</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9492"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>PACS실</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9438</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9438"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>임상의학연구소</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9667</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9667"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>의용공학팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9467</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9467"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>영양팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9131</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9131"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>가정간호</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9148</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9148"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                </ul>
                                          </div>     
                                       </TabPanel>

                                       <TabPanel value="7">
                                          <div className={style['phone-list']} data-type="b">
                                                <ul>
                                                   <li>
                                                      <p>간호부</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9661~2</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9661"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                </ul>
                                          </div>     
                                       </TabPanel>

                                       <TabPanel value="8">
                                          <div className={style['phone-list']} data-type="b">
                                                <ul>
                                                   <li>
                                                      <p>기획팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9411</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9411"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>홍보팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9414</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9414"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>PI팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9479</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9479"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>총무팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9035</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9035"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>감염관리팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9468</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9468"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>연구윤리사무국</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9211</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9211"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>CS팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9917</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9917"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>원무팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9451</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9451"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>재무팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9432</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9432"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>시설팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9470</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9470"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>적정진료관리팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9441</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9441"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>구매팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9463</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9463"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                   <li>
                                                      <p>정보보호팀</p>
                                                      <div className={style['group-box']}>
                                                         <ul>
                                                            <li>
                                                               <span>042-220-9482~4</span>
                                                               <CallButtonBox type="c" phoneNumber="042-220-9482"/>
                                                            </li>
                                                         </ul>
                                                      </div>
                                                   </li>
                                                </ul>
                                          </div>     
                                       </TabPanel>
                                    </div>
                                    
                              </TabContext> 
                           )}       
                           {/* 대전성모병원::S */}   
                            
                        </div>       
                    </div>
                </div>
                
            
        </>
    );
};

export default PhoneNumInfo;
